module.exports = __webpack_public_path__ + "static/media/gear.d7c11a2a.svg";